/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Architect_Output9Inputs */

const en_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service architecture`)
};

const ar_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معمارية الخدمة`)
};

const bn_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্ভিস আর্কিটেকচার`)
};

const de_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstarchitektur`)
};

const es_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura de servicio`)
};

const fr_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture des services`)
};

const pt_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura de serviço`)
};

const zh_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务架构`)
};

const tr_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet mimarisi`)
};

const ru_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архитектура сервиса`)
};

const pl_svc_backend_development_architect_output9 = /** @type {(inputs: Svc_Backend_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura usług`)
};

/**
* | output |
* | --- |
* | "Service architecture" |
*
* @param {Svc_Backend_Development_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_architect_output9 = /** @type {((inputs?: Svc_Backend_Development_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_architect_output9(inputs)
	if (locale === "bn") return bn_svc_backend_development_architect_output9(inputs)
	if (locale === "de") return de_svc_backend_development_architect_output9(inputs)
	if (locale === "es") return es_svc_backend_development_architect_output9(inputs)
	if (locale === "fr") return fr_svc_backend_development_architect_output9(inputs)
	if (locale === "pt") return pt_svc_backend_development_architect_output9(inputs)
	if (locale === "zh") return zh_svc_backend_development_architect_output9(inputs)
	if (locale === "tr") return tr_svc_backend_development_architect_output9(inputs)
	if (locale === "ru") return ru_svc_backend_development_architect_output9(inputs)
	if (locale === "pl") return pl_svc_backend_development_architect_output9(inputs)
	return en_svc_backend_development_architect_output9(inputs)
});
export { svc_backend_development_architect_output9 as "svc_backend-development_ARCHITECT_output" }